import { Component, OnInit } from '@angular/core';
import {FormCheckPolicyService} from '../service/form-check-policy.service';
import {UntypedFormBuilder, Validators, UntypedFormGroup, UntypedFormArray, UntypedFormControl} from '@angular/forms';
import {Router} from '@angular/router';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import {ModalsConfirmComponent} from './modals-confirm/modals-confirm.component';
import { NgxSpinnerService } from 'ngx-spinner';
import { environment } from 'src/environments/environment';
import { ModErrorComponent } from '../modals/mod-error/mod-error.component';

@Component({
  selector: 'app-form-check-policy',
  templateUrl: './form-check-policy.component.html'
})
export class FormCheckPolicyComponent implements OnInit{
  formPolicy: UntypedFormGroup;
  sites: any [] = [];
  types: any [] = [];
  selection: string;
  selected: string;
  checkboxError = false;
  confirmError = false;
  fileName = 'false';
  fileError = false;
  file: object;
  submited= false;
  typesCheck=false;
  urlExcel = environment.urlExampleFileEmployee;


  selectSite= false;
  fileformat= false;
  filesize= false;

  constructor(private dataApi: FormCheckPolicyService, private router: Router, public dialog: MatDialog, private formBuilder: UntypedFormBuilder,
              private spinner: NgxSpinnerService, private _snackBar: MatSnackBar ) {


  }

  downloadExcel(){
    window.window.open(this.urlExcel);
  }

  ngOnInit() {
    this.formPolicy = this.formBuilder.group({
      siteId: ['', Validators.required],
      type: new UntypedFormArray([], Validators.required),
      commentary: [''],
      Confirm:[false, Validators.required]
    });
    this.spinner.show("loading");
    this.dataApi.getCheckPolicy().subscribe((data: any) => {
      this.spinner.hide("loading");
      this.sites = data.sites;
      this.types = data.types;
      if(this.formPolicy.get('type')?.value.length === 0) {//el FormArray está vacío
        this.formPolicy.controls['type'].setValue(String(data.types[0].id));
      }},
                                            (err) => {
                                              this.spinner.hide("loading");
                                              if(err.error.error !== 'Invalid token.') {
                                                this.dialog.open(ModErrorComponent, {
                                                  width: 'auto',
                                                  panelClass: 'myapp-no-padding-dialog',
                                                });
                                              }
                                            });
  }
  getlang(){

    return sessionStorage.getItem('lang');
  }


  openDialog() {
    this.dialog.open(ModalsConfirmComponent, {panelClass: 'myapp-no-padding-dialog'}).afterClosed().subscribe((accept: boolean) => {
      if (accept) {
        this.formPolicy.controls['Confirm'].setValue(true);
      }
    });
  }
  detectFiles(event) {
    this.fileformat= false;
    this.filesize= false;
    const selectedFiles = event.target.files;
    const names = selectedFiles[0].name.split('.')
    if(selectedFiles[0].size >= 15000000){
      this.filesize = true;
      return;
    }
    this.filesize = false;
    if (selectedFiles[0].type === 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' &&
    names[names.length - 1].toLocaleLowerCase() === 'xlsx'
    ) {
      this.file = selectedFiles[0];
      this.fileName = selectedFiles[0].name;
      this.fileformat = false;
    } else {
      this.file = null;
      this.fileName = 'false';
      this.fileformat = true;
    }

    event.srcElement.value = null;
  }
  goTo(id: string) {
    const el = document.getElementById(id);
    el.scrollIntoView();
  }
  onCheckChange(event) {
    const formArray: UntypedFormArray = this.formPolicy.get('type') as UntypedFormArray;

    /* Selected */
    if(event.target.checked){
      // Add a new control in the arrayForm
      formArray.push(new UntypedFormControl(event.target.value));
    }
    /* unselected */
    else{
      // find the unselected element
      let i: number = 0;

      formArray.controls.forEach((ctrl: UntypedFormControl) => {
        if(ctrl.value == event.target.value) {
          // Remove the unselected element from the arrayForm
          formArray.removeAt(i);
          return;
        }

        i++;

      });
    }

  }


  onSubmit() {
    this.submited=true;
   this.typesCheck=false;
    if (!this.formPolicy.controls.siteId.valid    ) {
      this.goTo('RequestDetail');
    } else{
      if (!this.formPolicy.controls.type.valid) {
        this.goTo('radio-type');
        this.typesCheck=true;
      } else {
        if (this.fileName === 'false') {
          this.fileError = true;
        } else{
          if(this.formPolicy.value.Confirm === '' || this.formPolicy.value.Confirm === false){
            this.confirmError = true;
          } else{
            if(this.formPolicy.valid){
              this.spinner.show('loading');
              this.dataApi.postCheckPolicy(
                this.formPolicy.value.siteId,
                this.formPolicy.value.type,
                this.formPolicy.value.commentary,
                this.file
              ).subscribe(
                (response: any) => {
                  this.router.navigate(['/policy/detail', 'request' , response.id]).then( (e) => {
                    if (e) {
                      this.spinner.hide("loading");

                    }
                  });
                },
                (err) => {
                  this.spinner.hide("loading");
                  if(err.error.error !== 'Invalid token.') {
                    this.dialog.open(ModErrorComponent, {
                      width: 'auto',
                      panelClass: 'myapp-no-padding-dialog',
                    });
                  }
                }
              );
            }
          }
        }
      }
    }

  }

}
